import { useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../store/redux/hooks'
import { PageIndex, setPageIndex, setPageName } from '../../store/redux/reducers/pageNameSlice'
import { StyledContainerColumnLeft, StyledContainerRowStart } from '../../styles/ContainerStyles'
import ReportsTypeTiles from './ReportsTypeTiles'
import ReportGenerationPanel from './ReportGenerationPanel'
import { reportTiles, ReportTileValue } from '../../store/constants/reportConstants'

const ReportsView = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setPageName(t('page.name.reports')))
    dispatch(setPageIndex(PageIndex.REPORTS))
  }, [dispatch, t])

  const theme = useTheme()
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))

  const [selectedTile, setSelectedTile] = useState<ReportTileValue | null>(reportTiles.PROJECTS)

  return (
    <StyledContainerRowStart
      sx={{
        gap: 4.5,
        color: 'text.base',
        flexDirection: isDownLg ? 'column' : 'row',
        pr: isDownSm ? 0 : 2,
        paddingBottom: 3,
      }}
    >
      <StyledContainerColumnLeft
        sx={{ gap: 3.5, width: isDownLg ? '100%' : '35%', height: 'auto', alignSelf: 'flex-start' }}
      >
        <ReportsTypeTiles selectedTile={selectedTile} onSelect={setSelectedTile} />
      </StyledContainerColumnLeft>

      <StyledContainerColumnLeft
        sx={{ gap: 3.5, width: isDownLg ? '100%' : '65%', height: 'auto', alignSelf: 'flex-start' }}
      >
        <ReportGenerationPanel selectedTile={selectedTile} />
      </StyledContainerColumnLeft>
    </StyledContainerRowStart>
  )
}

export default ReportsView
